// extracted by mini-css-extract-plugin
export default {"containerError":"Error_containerError__u6Cuw"};